import { useMutation } from "@apollo/client";
import { IconButton, TableCell, TableRow } from "@mui/material";
import { format } from "date-fns";
import React from "react";

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { formatTime, showToastMessage } from "src/coach/service/coach.utils";
import { useLoading } from "src/shared/hooks/use-loading";
import { useModal } from "src/shared/hooks/use-modal";
import AddAvailability from "../addAvailability";
import { deleteAvailabilityPeriodMutation } from "../graphql/availability-mutation";
import { ShortWeekdays } from "../helper";
import { DeleteAvailability } from "./deleteAvailability";



export const AvailabilityPeriodItemDesktop = ({availabilityPeriod, refetch, showActions,key,franchises }) => {
  const { loading: loadingState } = useLoading();
  const { isOpen:isOpenDelete, actions:deleteActions } = useModal();
  const { isOpen:isOpenUpsert, actions:upsertActions } = useModal();
  const dateRange = `${format(
    new Date(availabilityPeriod.startDate),
    'MM/dd/yyy',
  )} - ${format(new Date(availabilityPeriod.endDate), 'MM/dd/yyy')}`;
  const timeRange = `${formatTime(availabilityPeriod.startTime)} - ${formatTime(
    availabilityPeriod.endTime,
  )}`;
  const [
    mutationDeleteAvailabilityPeriod,
    { loading: deleteAvailabilityPeriodLoading },
  ] = useMutation(deleteAvailabilityPeriodMutation);
  const handleDeleteAvailabilityPeriod = async (franchiseIds) => {
    try {
      loadingState.start();
      await mutationDeleteAvailabilityPeriod({
        variables: {
          input:{
            id: availabilityPeriod.id,
            franchiseIds: franchiseIds,
          }
        },
      });
      await refetch();
      showToastMessage('Availability removed successfully');
    } catch {
      showToastMessage('Could not able to remove Availability','error');
    } finally {
      loadingState.stop();
    }
  };

 
  return (
    <TableRow key={key} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      {/* <TableCell>{availabilityPeriod.id}</TableCell> */}
      <TableCell>{ShortWeekdays[availabilityPeriod.dayOfWeek]}</TableCell>
      <TableCell>{dateRange}</TableCell>
      <TableCell>{timeRange}</TableCell>
      {showActions && (
        <TableCell className="tw-flex tw-gap-3">
          <IconButton onClick={() => upsertActions.open()}>
            <EditIcon />
          </IconButton>
          <IconButton onClick={() => deleteActions.open()}>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      )}
      {isOpenDelete && (
        <DeleteAvailability
        $message={
          <div className='tw-flex tw-flex-col tw-gap-4'>
          <p>
          Are you sure you want to remove availability for{' '}
          <b>{ShortWeekdays[availabilityPeriod.dayOfWeek]}</b>,
          <b>{dateRange}</b> from <b>{timeRange}</b>?
          </p>
          </div>
          } 
        $onConfirm={handleDeleteAvailabilityPeriod}
        $loading={deleteAvailabilityPeriodLoading || loadingState.get}
        $actions={deleteActions}
        $title='Remove Availability'
        franchises={availabilityPeriod?.periodFranchises||[]}

      />
      )}
      {isOpenUpsert && (
        <AddAvailability
          coachId={availabilityPeriod.resourceId}
          editAvailabilityPeriod={availabilityPeriod}
          actions={upsertActions}
          title={'Edit Availability'}
          refetch={refetch}
          franchises={franchises}
        />
      )}
    </TableRow>
  );
};